import Main from "../layout/Main";
import FinancialYearDashboard from "./financialYear/FinancialYearDashboard";

const Home = () => (
  <Main>
    <FinancialYearDashboard />
  </Main>
);

export default Home;
